import DocViewer from '@cyntler/react-doc-viewer'
import { Box, BoxProps } from '@mui/material'
import React from 'react'
import ReactPlayer from 'react-player'
import { connect } from 'react-redux'
import { DOC_VIEWER_SUPPORTED_FILES } from 'constants/common'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import {
  Operations as UserAdminOperations,
  operations as userAdminOperations
} from 'states/dux/user-admin/operations'
import { Payload as UserAdminPayload } from 'states/dux/user-admin/types'
import {
  Operations as UserOperations,
  operations as userOperations
} from 'states/dux/user/operations'
import { Payload as UserPayload } from 'states/dux/user/types'
import State from 'states/types'
import { NivosFile } from 'types/nivos-file'
import { mapOperationsToDispatchProps, trusty } from 'utils/common'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
  user: UserPayload
  userAdmin: UserAdminPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
    user: UserOperations
    userAdmin: UserAdminOperations
  }
}

interface OwnProps {
  file: NivosFile
  containerProps?: BoxProps
  disableClickInteraction?: boolean
}

type AppProps = StateProps & DispatchProps & OwnProps

const DocumentFilePreviewFC: React.FC<any> = (props: AppProps) => {
  const { file, containerProps, disableClickInteraction, theme } = props

  return (
    <Box {...containerProps}>
      {DOC_VIEWER_SUPPORTED_FILES.includes(file.fileType) && (
        <DocViewer
          documents={[{ uri: file.url, fileType: file.fileType.toLowerCase() }]}
          theme={{
            primary: theme.primaryColor,
            secondary: theme.secondaryColor,
            tertiary: theme.tertiaryColor,
            textPrimary: 'white'
          }}
          config={{
            header: {
              disableHeader: true
            }
          }}
          style={{
            backgroundColor: theme.primaryColor
          }}
          activeDocument={{
            uri: file.url,
            fileType: file.fileType.toLowerCase()
          }}
        />
      )}
      {file.fileType === 'VIDEO' && (
        <ReactPlayer
          url={file.url}
          controls={!trusty(disableClickInteraction)}
          height={'100%'}
          width={'100%'}
          muted={trusty(disableClickInteraction)}
          playing={trusty(disableClickInteraction)}
        />
      )}
    </Box>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout,
    user: state.user,
    userAdmin: state.userAdmin
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations,
  user: userOperations,
  userAdmin: userAdminOperations
})

const DocumentFilePreview = connect(
  mapStateToProps,
  mapDispatchToProps
)(DocumentFilePreviewFC) as React.FC<OwnProps>

export default React.memo(DocumentFilePreview)
